var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutBase",
    [
      _c("header", { attrs: { id: "content__header" } }, [
        _c("h1", [_vm._v("Here's what you've missed")]),
      ]),
      _vm._v(" "),
      !this.$store.getters.registrationCompleted &&
      this.$store.getters.eventLoading
        ? _c("EventModal", {
            attrs: { "curr-event": this.$store.getters.event },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "grid", attrs: { id: "stats" } }, [
        _c(
          "div",
          { staticClass: "col-6 col-md-4 col-grid" },
          [
            _c(
              "router-link",
              {
                staticClass: "card card--stat",
                attrs: { to: { name: "dashboard" } },
              },
              [
                _c("SvgIcon", {
                  staticClass: "card__icon",
                  attrs: { icon: "dashboard-opportunities" },
                }),
                _vm._v(" "),
                _c("span", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.counts.opportunities || "-")),
                  ]),
                  _vm._v("\n\t\t\t\t\t\tNew Opportunities\n\t\t\t\t\t"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6 col-md-4 col-grid" },
          [
            _c(
              "router-link",
              {
                staticClass: "card card--stat",
                attrs: {
                  to: { name: "dashboard", params: { tab: "madds" } },
                  replace: "",
                },
              },
              [
                _c("SvgIcon", {
                  staticClass: "card__icon",
                  attrs: { icon: "dashboard-madds" },
                }),
                _vm._v(" "),
                _c("span", [
                  _c("strong", [_vm._v(_vm._s(_vm.counts.madds || "-"))]),
                  _vm._v("\n\t\t\t\t\t\tNew MADDs\n\t\t\t\t\t"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6 col-md-4 col-grid" },
          [
            _c(
              "router-link",
              {
                staticClass: "card card--stat",
                attrs: {
                  to: { name: "dashboard", params: { tab: "insights" } },
                  replace: "",
                },
              },
              [
                _c("SvgIcon", {
                  staticClass: "card__icon",
                  attrs: { icon: "dashboard-insights" },
                }),
                _vm._v(" "),
                _c("span", [
                  _c("strong", [_vm._v(_vm._s(_vm.counts.insights || "-"))]),
                  _vm._v("\n\t\t\t\t\t\tNew Insights\n\t\t\t\t\t"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "vue-tabs",
        { ref: "tabs", on: { "tab-change": _vm.onTabChange } },
        [
          _c(
            "v-tab",
            { attrs: { id: "opportunities", title: "Opportunities" } },
            [
              _c("ListOpportunities", {
                ref: "opportunities",
                attrs: { "load-on-start": false, "new-only": true },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "madds", title: "MADDs" } },
            [
              _c("ListMADDs", {
                ref: "madds",
                attrs: { "load-on-start": false, "new-only": true },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "insights", title: "Insights" } },
            [
              _c("ListInsights", {
                ref: "insights",
                attrs: { "load-on-start": false, "new-only": true },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }